import { render, staticRenderFns } from "./InstructorWarnings.vue?vue&type=template&id=c74dba1e&scoped=true"
import script from "./InstructorWarnings.vue?vue&type=script&lang=js"
export * from "./InstructorWarnings.vue?vue&type=script&lang=js"
import style0 from "./InstructorWarnings.vue?vue&type=style&index=0&id=c74dba1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74dba1e",
  null
  
)

export default component.exports